// Copyright (c) StrangeBee 2024

import { BrandingController, BrandingParams } from 'thehive-sdk';

export interface BrandingEventList {
    onEdit: (brandingData: BrandingParams) => void;
    onDelete: (kind: string) => void;
}

interface BrandingEventListParams {
    locale: (label: string, opt?: Record<string, any>) => string;
    controller: BrandingController;
    onSuccess?: (message?: string) => void;
    onError?: (label?: string) => void;
}

export const computeEventList = ({
    controller,
    locale,
    onError,
    onSuccess,
}: BrandingEventListParams): BrandingEventList => ({
    onEdit: (brandingData: BrandingParams): void => {
        const editData = Object.entries(brandingData).reduce((acc: FormData, [name, value]): FormData => {
            if (name === 'title' || typeof value === 'object') {
                acc.set(name, value as any);
            }
            return acc;
        }, new FormData());

        controller
            .edit(editData)
            .then(() => onSuccess?.(locale('branding.edited.success')))

            .catch(onError);
    },
    onDelete: (kind: string): void => {
        controller
            .delete(kind as keyof BrandingParams)
            .then(() => onSuccess?.(locale('branding.deleted.success', { kind })))
            .catch(onError);
    },
});
